/* RESPONSIBLE TEAM: team-proactive-support */
import Model, { attr } from '@ember-data/model';

export default class OutboundTwilioKeywordResponses extends Model {
  @attr('string') declare unhandledKeyword: string;
}
